import React from "react";

export const DisplayPercentage = ({ value = 0, precision = 2, withSuffix }) => {
  if (value === null) {
    return;
  }
  return (
    <span>
      {value.toFixed(precision)}
      {withSuffix ? "%" : ""}
    </span>
  );
};

export const DisplayPercentageCell = ({ getValue }) => {
  return <DisplayPercentage value={getValue()} />;
};
